import type { SupportMessengerProvider } from './types';
import { createSupportMessengerProvider, SUPPORT_PROVIDER_NAME } from './intercom';

/**
 * Returns null (never throws) for an unknown VITE_SUPPORT_PROVIDER value. This runs in the
 * app's RENDER path (useSupportMessenger calls it directly, not inside an effect), so a typo
 * in an env var must degrade to "widget off" rather than crash the whole app for every visitor.
 */
export function getSupportMessengerProvider(appId: string): SupportMessengerProvider | null {
  const p = (import.meta.env.VITE_SUPPORT_PROVIDER as string | undefined) || SUPPORT_PROVIDER_NAME;
  if (p === SUPPORT_PROVIDER_NAME) return createSupportMessengerProvider(appId);
  console.warn(`[support] unknown VITE_SUPPORT_PROVIDER "${p}" — support widget disabled`);
  return null;
}
